import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { formatAssetsUrl } from '@whitbread-eos/utils';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useMemo } from 'react';
import { ACCEPTED_HOTEL_CARD_FACILITIES, ACCESSIBLE_FACILITY_CODES, AIR_CONDITIONING_FACILITY_CODES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('@whitbread-eos/atoms'),
    Tooltip = _yield$import.Tooltip;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
export default function HotelFacilities(_ref2) {
  var facilities = _ref2.facilities,
    roomTypes = _ref2.roomTypes,
    isDLPPage = _ref2.isDLPPage,
    testId = _ref2.testId;
  var srpFacilities = useMemo(() => {
    var airConditioningFacility = facilities.filter(facility => {
      var _facility$code;
      return AIR_CONDITIONING_FACILITY_CODES.flat().includes((_facility$code = facility === null || facility === void 0 ? void 0 : facility.code) !== null && _facility$code !== void 0 ? _facility$code : '');
    });
    var accessibleFacility = facilities.filter(facility => {
      var _facility$code2;
      return ACCESSIBLE_FACILITY_CODES.flat().includes((_facility$code2 = facility === null || facility === void 0 ? void 0 : facility.code) !== null && _facility$code2 !== void 0 ? _facility$code2 : '');
    });
    var otherFacilities = facilities.filter(facility => {
      var _facility$code3;
      return ACCEPTED_HOTEL_CARD_FACILITIES.flat().includes((_facility$code3 = facility === null || facility === void 0 ? void 0 : facility.code) !== null && _facility$code3 !== void 0 ? _facility$code3 : '');
    });
    var uniqueFacilities = [...airConditioningFacility, ...otherFacilities];
    if (roomTypes !== null && roomTypes !== void 0 && roomTypes.includes('DIS')) {
      return uniqueFacilities.concat(...accessibleFacility);
    }
    return uniqueFacilities;
  }, [facilities, roomTypes]);
  var dlpFacilities = useMemo(() => {
    return facilities.filter(facility => facility.isVisible).slice(0, 4);
  }, [facilities]);
  var facilitiesList = isDLPPage ? dlpFacilities : srpFacilities;
  return _jsx(Flex, {
    "data-testid": testId,
    children: facilitiesList.map(facility => {
      var _facility$name, _facility$icon, _facility$name2;
      return _jsx(Tooltip, _objectSpread(_objectSpread({
        description: (_facility$name = facility === null || facility === void 0 ? void 0 : facility.name) !== null && _facility$name !== void 0 ? _facility$name : '',
        variant: "facilities",
        placement: "bottom-start",
        position: "relative",
        alertElementStyles: alertStyles
      }, tooltipStyles), {}, {
        children: _jsx(Box, {
          as: "span",
          mr: "xmd",
          "data-testid": facility.name,
          children: _jsx(Image, {
            width: 25,
            height: 24,
            src: formatAssetsUrl((_facility$icon = facility === null || facility === void 0 ? void 0 : facility.icon) !== null && _facility$icon !== void 0 ? _facility$icon : ''),
            alt: (_facility$name2 = facility === null || facility === void 0 ? void 0 : facility.name) !== null && _facility$name2 !== void 0 ? _facility$name2 : '',
            "data-testid": "svg-container"
          })
        })
      }), facility.code);
    })
  });
}
var alertStyles = {
  py: 'sm',
  padding: 0,
  h: '2.125rem'
};
var tooltipStyles = {
  marginLeft: '-1.2rem',
  fontSize: 'sm',
  lineHeight: '3',
  paddingLeft: 0,
  fontWeight: 'normal',
  top: 'xs'
};